import Vue from 'vue'

// ========================
// Router
// ========================
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes
})

// ========================
// i18n
// ========================
import VueI18n from 'vue-i18n'
import locales from './language/locales'

Vue.use(VueI18n)

Object.keys(locales).forEach((lang) => {
  Vue.locale(lang, locales[lang])
})

Vue.config.lang = 'pt-BR';

// ========================
// Directives
// ========================
import Focus from './directives/focus'

Vue.directive('focus', Focus)

// ========================
// Filters
// ========================
import Reverse from './filters/reverse'

Vue.filter('reverse', Reverse)

// ========================
// Resource
// ========================
import VueResource from 'vue-resource';

Vue.use(VueResource);

// ========================
// Segment
// ========================
import Segment from './utils/segment'


// ========================
// EventHub
// ========================
window.eventHub = new Vue();


// ========================
// App
// ========================
new Vue({
  router,
  template: `
    <div id="app">
      <router-view class="view"></router-view>
    </div>
  `,
  created () {
    if (process.ENV === 'sandbox' || process.ENV === 'production') {
      Segment();
    }
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js